<template>
  <div>
    <div v-if="tokens?.length === 0">
      <h3>Você ainda não criou nenhum token!</h3>
      <div>
        <p>
          Você ainda não criou um token de acesso para o Playground, acesse a a página de
          <b>Criar tokens</b>
          e gere um token que possa ser utilizado no Playground.
        </p>
        <div class="v--text-center">
          <a href="/tokens/criar?playground=1">
            <button class="btn _mb">
              <b>Criar Token</b>
            </button>
          </a>
        </div>
      </div>
    </div>

    <div v-else>
      <h1 class="text-2xl font-bold mb-6">Playground</h1>
      <div class="form-box">
        <select
          name="selectServicos"
          v-model="servico"
          class="field px-3 rounded-md text-sm w-xs"
        >
          <option v-for="servico in servicosPlayground" :value="servico">
            {{ servico.nome }}
          </option>
        </select>
      </div>

      <div class="form-box space-y-2">
        <label class="text-sm font-medium">Token de acesso</label>
        <select
          name="selectTokens"
          v-model="token"
          class="field px-3 rounded-md text-sm"
        >
          <option v-for="token in tokens" :value="token">
            {{ token.name }}
          </option>
        </select>
      </div>

      <KeepAlive>
        <component
          :is="servico.identificador"
          :identificador="servico.identificador"
          :token="token.id"
          :extra="adicional"
        >
          <template v-slot:custo>
            <CustoConsulta :custo="custo" :tipo="tipo"/>
          </template>
        </component>
      </KeepAlive>
    </div>
  </div>
</template>

<script>
import Response from "./playground/ResultadoApi";
import EnvolvidoProcessos from "./playground/EnvolvidoProcessos";
import ButtonLoading from "../_www/Button/ButtonLoading";
import OabProcessos from "./playground/OabProcessos";
import CapaProcessos from "./playground/CapaProcesso";
import CustoConsulta from "./playground/CustoConsulta.vue";
import AtualizacaoProcesso from "./playground/AtualizacaoProcesso.vue";
import StatusAtualizacaoProcesso from "./playground/StatusAtualizacaoProcesso.vue";
import {IdentificadorServico} from "../../utils/identificadores-servicos-api";
import AtualizacaoProcessoResumoIA from "./playground/AtualizacaoProcessoResumoIA.vue";
import StatusAtualizacaoProcessoResumoIA from "./playground/StatusAtualizacaoProcessoResumoIA.vue";
import ProcessoResumoIA from "./playground/ProcessoResumoIA.vue";
import ProcessoMovimentacoes from "./playground/ProcessoMovimentacoes.vue";

export default {
  name: "PlaygroundApi",
  components: {
    CustoConsulta,
    [IdentificadorServico.OAB_PROCESSOS] : OabProcessos,
    [IdentificadorServico.ENVOLVIDO_PROCESSOS] : EnvolvidoProcessos,
    [IdentificadorServico.CAPA_PROCESSO]: CapaProcessos,
    [IdentificadorServico.ATUALIZACAO_PROCESSO]: AtualizacaoProcesso,
    [IdentificadorServico.STATUS_ATUALIZACAO_PROCESSO] : StatusAtualizacaoProcesso,
    [IdentificadorServico.ATUALIZACAO_PROCESSO_RESUMO_IA]: AtualizacaoProcessoResumoIA,
    [IdentificadorServico.STATUS_RESUMO_INTELIGENTE]: StatusAtualizacaoProcessoResumoIA,
    [IdentificadorServico.PROCESSO_RESUMO_IA]: ProcessoResumoIA,
    [IdentificadorServico.PROCESSO_MOVIMENTACOES] : ProcessoMovimentacoes,
    ButtonLoading,
    Response
  },
  props: {
    servicosPlayground: {
      type: Array,
      required: true,
    },
    tokens: {
      type: Array,
      required: true,
    },
    estados: {
      type: Array,
      required: true,
    },
    tribunais: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      servico: this.servicosPlayground[0],
      token: this.tokens[0],
    };
  },
  computed: {
    custo() {
      let servico = this.servico;

      if (servico["preco_usuario"]['valor'] === 0) {
        return {
          valor: 'Gratuito'
        }
      }

      if (servico["preco_usuario"]["quantidadeIsenta"]) {
        let valor = (servico["preco_usuario"].valor / 100).toLocaleString(
          "pt-BR",
          { style: "currency", currency: "BRL" }
        );

        let valorDesconto = (
          servico["preco_usuario"]["valorExtra"] / 100
        ).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

        return {
          valor: valor,
          valor_desconto: valorDesconto,
          faixa: servico["preco_usuario"]["tamanhoFaixa"],
          faixa_tipo:
            servico.identificador === "MONITORAMENTO"
              ? "resultados/mês"
              : "itens",
        };
      }

      let complemento =
        servico.categoria === "Monitoramento no site do Tribunal" ||
        servico.categoria === "Monitoramento de Diários Oficiais" ? " / mês" : ""

      return {
        valor: (servico["preco_usuario"].valor / 100).toLocaleString("pt-BR", {
           style: "currency",
           currency: "BRL",
         }) + complemento
      }
    },
    adicional() {
      if (this.servico.identificador === IdentificadorServico.OAB_PROCESSOS) {
        return {
          estados: this.estados,
          tribunais: this.tribunais
        }
      }

      if (this.servico.identificador === IdentificadorServico.ENVOLVIDO_PROCESSOS) {
        return {
          tribunais: this.tribunais
        }
      }
    },
    tipo() {
      return this.servico.identificador === IdentificadorServico.ATUALIZACAO_PROCESSO ? 'atualização' : 'consulta';
    }
  },
  methods: {
    atualizarSaldoView(valor = 0) {
      let boxCredito = document.querySelector('#box-credito-api');

      if (!boxCredito) return;

      let valorElement = boxCredito.children[2];

      if (!valorElement) return;

      if (this.contrato['pospago']) {
        this.contrato.saldo = Math.abs(this.contrato.saldo) + valor;

        let progress = boxCredito.children[3];

        if (progress) {
          progress.value = this.contrato.saldo;

          let porcentagem = (progress.value / progress.max) * 100;
          progress.textContent = porcentagem.toFixed(2) + '%';
          if (porcentagem > 70) {
            progress.style.accentColor= "red";
          }
        }

      } else {
        this.contrato.saldo = this.contrato.saldo - valor;
        if (this.contrato.saldo < this.contrato.limite) valorElement.classList.add('valor-limite');
      }

      valorElement.textContent = 'R$ ' + (this.contrato.saldo / 100).toLocaleString(
        'pt-br',
        { minimumFractionDigits: 2 }
      )
    }
  }
};
</script>

<style scoped lang="stylus">
select
  width 320px

select
  @media screen and (min-width: 768px)
    max-width 350px !important
</style>
